import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  refillBalance,
  annulStoreErrors,
  deleteCard,
  getBalanceHistory,
} from '../../reducers/payment/duck';
import { getProfile, getProfileStatus } from '../../reducers/user/duck';
import { getAppCampaigns } from '../../reducers/create-campaign/duck';
import BalanceScreen from './BalanceScreen';

const mapStateToProps = ({
  userStore: { balance, cardMethod, invoiceMethod },
  paymentStore: {
    refillBalanceStatus,
    refillBalanceError,
    balanceHistory,
    hasMoreBalanceHistory,
    balanceHistoryPage,
  },
  campaignStore: { currentAppCampaigns, getAppCampaignsStatus },
  createAppStore: { apps },
}) => ({
  balance,
  refillBalanceStatus,
  refillBalanceError,
  cardMethod,
  invoiceMethod,
  balanceHistory,
  hasMoreBalanceHistory,
  balanceHistoryPage,
  currentAppCampaigns,
  getAppCampaignsStatus,
  apps,
});
const mapDispatchToProps = {
  refillBalance,
  getProfile,
  annulStoreErrors,
  deleteCard,
  getProfileStatus,
  getBalanceHistory,
  getAppCampaigns,
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(BalanceScreen));



// WEBPACK FOOTER //
// ./src/containers/BalanceScreen/index.js